import {BaseElementAsync, OSkinableInit} from "/@back@/commons/basis.js";
import {IApp, IAppCtx} from "/@back@/core/appFrame.js";
import {JDynGenAppDef} from "/@back@/wsp/plugins/dynGenPlg.js";

import "/@back@/wsp/views/views_Perms.js";
import {JSX} from "/@lib@/commons/xml/dom.js";
import {IChainEnv} from "/@lib@/wsp/chain.js";
import {DynGen, ODynGenInit} from "/@back@/wsp/views/dynGen.js";
import {IView, IViewContainer, OViewVisitOptions} from "/@lib@/commons/views.js";
import {REG} from "/@lib@/commons/registry.js";
import {DOMSH} from "/@lib@/commons/xml/domsh.js";

export interface DynGenApp extends BaseElementAsync {
	initialize(init: IAppCtx<IChainEnv> & OSkinableInit): this;
}

export class DynGenApp extends BaseElementAsync implements IApp<IChainEnv>, IViewContainer {

	appDef: JDynGenAppDef;

	view: DynGen;

	protected async _initialize(init: IAppCtx<IChainEnv> & OSkinableInit) {
		this.appDef = init.appDef as JDynGenAppDef;
		this.attachShadow(DOMSH.SHADOWDOM_INIT);
		this._initAndInstallSkin(this.localName, init);
		const subInit = Object.create(this.appDef.dynGen) as ODynGenInit;
		subInit.reg = init.reg;
		this.view = this.shadowRoot.appendChild(new DynGen().initialize(subInit));
	}

	updateAppDef(def: JDynGenAppDef): boolean {
		//A voir.
		return false;
	}

	visitViews(visitor: (view: IView) => any): any {
		if (this.view) return visitor(this.view);
	}

	visitViewsAsync(visitor: (view: IView) => Promise<any>, options?: OViewVisitOptions): Promise<any> {
		return this.view ? visitor(this.view) : Promise.resolve(undefined);
	}
}

REG.reg.registerSkin('wsp-dyngen-app', 1, /* language=CSS */ `
	:host {
		flex: 1;
		display: flex;
		min-height: 0;
		min-width: 0;
	}
`);
customElements.define('wsp-dyngen-app', DynGenApp);
